/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Issue_S3Inputs */

const en_mk_tut_issue_s3 = /** @type {(inputs: Mk_Tut_Issue_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a status, a priority, an assignee and a due date if there is one. All of them may be left empty and filled in later.`)
};

const id_mk_tut_issue_s3 = /** @type {(inputs: Mk_Tut_Issue_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih status, prioritas, penanggung jawab, dan tenggat kalau ada. Semua boleh dikosongkan dan diisi belakangan.`)
};

/**
* | output |
* | --- |
* | "Pick a status, a priority, an assignee and a due date if there is one. All of them may be left empty and filled in later." |
*
* @param {Mk_Tut_Issue_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_issue_s3 = /** @type {((inputs?: Mk_Tut_Issue_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Issue_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_issue_s3(inputs)
	return en_mk_tut_issue_s3(inputs)
});